// ---------------------------------------------------------------------------
// HOTEL DESK - GLOBAL DESIGN TOKENS
// Single source of truth for the application's visual language. Every UI
// component and page consumes these - never hard-code a colour, radius,
// shadow or spacing value in a page again.
// ---------------------------------------------------------------------------

/** Brand + semantic colours. */
export const color = {
  primary: '#0F172A',
  accent: 'var(--hd-info, #2563eb)',
  accentHover: '#1D4ED8',
  accentSoft: '#EFF6FF',

  success: 'var(--hd-success, #22c55e)',
  successSoft: '#F0FDF4',
  warning: 'var(--hd-warning, #f59e0b)',
  warningSoft: '#FFFBEB',
  danger: 'var(--hd-danger, #ef4444)',
  dangerSoft: '#FEF2F2',
  info: 'var(--hd-info, #0ea5e9)',
  infoSoft: '#F0F9FF',

  bg: 'var(--hd-page-bg, #f8fafc)',
  surface: 'var(--hd-surface, #ffffff)',
  surfaceAlt: '#F8FAFC',

  text: 'var(--hd-text-primary, #0f172a)',
  textMuted: 'var(--hd-text-secondary, #64748b)',
  textFaint: 'var(--hd-text-muted, #94a3b8)',

  border: 'var(--hd-border, #e2e8f0)',
  borderStrong: '#CBD5E1',
};

/** 4px base spacing scale. */
export const space = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32 };

/** Corner radii - 12px is the product standard for cards. */
export const radius = { sm: 6, md: 8, lg: 12, pill: 999 };

/** Soft, layered shadows - never heavy or coloured. */
export const shadow = {
  none: 'none',
  sm: '0 1px 2px rgba(15,23,42,0.04)',
  card: '0 1px 3px rgba(15,23,42,0.06), 0 1px 2px rgba(15,23,42,0.04)',
  raised: '0 4px 12px rgba(15,23,42,0.08)',
  overlay: '0 12px 28px rgba(15,23,42,0.12)',
};

/** Typography scale - Inter, already loaded globally in index.css. */
export const font = {
  family: "'Inter', 'Manrope', -apple-system, 'Segoe UI', sans-serif",
  pageTitle: { fontSize: 18, fontWeight: 700, letterSpacing: -0.2 },
  sectionTitle: { fontSize: 14, fontWeight: 700 },
  label: { fontSize: 12, fontWeight: 600 },
  body: { fontSize: 13, fontWeight: 400 },
  helper: { fontSize: 11.5, fontWeight: 400 },
  kpiValue: { fontSize: 22, fontWeight: 800, letterSpacing: -0.4 },
};

/** Fixed control height - keeps every filter/button on one crisp line. */
export const control = { height: 36 };

const tokens = { color, space, radius, shadow, font, control };
export default tokens;